import { FunctionComponent } from 'react';
import styles from './TierCheckbox.module.scss';

type TierCheckboxProps = {
  name: string;
  label: string;
  checked: boolean;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
};

const TierCheckbox: FunctionComponent<TierCheckboxProps> = ({ name, label, checked, disabled = false, onChange }) => {
  return (
    <label className={`${styles.container} ${disabled ? styles.disabled : ''}`}>
      <input
        type="checkbox"
        className={styles.checkbox}
        name={name}
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span className={styles.label}>{label}</span>
    </label>
  );
};

export default TierCheckbox;
